const constants: c = {
  settings: {
    bgNumber: 4,
  },
  game: {
    easy: {
      maxQuestions: 50,
      stepScore: 5,
      skipTO: parseInt(process.env.REACT_APP_LATENCY_TIME),
      maxErrorsPerQuestion: 0,
      maxWrongQuestion: 5,
      options: 2,
      userResponseTO: 30,
    },
    hard: {
      maxQuestions: 100,
      stepScore: 5,
      skipTO: parseInt(process.env.REACT_APP_LATENCY_TIME),
      maxErrorsPerQuestion: 0,
      maxWrongQuestion: 2,
      options: 3,
      userResponseTO: 20,
    },
  },
  rest: {
    errorCodes: {
      notFound: 'NOT-FOUND',
    },
  },
  tp: {
    fbPixelId: '193710088110660',
  },
};

interface c {
  settings: {
    bgNumber: number;
  };
  game: {
    easy: {
      maxQuestions: number;
      stepScore: number;
      skipTO: number;
      maxErrorsPerQuestion: number;
      maxWrongQuestion: number;
      options: number;
      userResponseTO: number;
    };
    hard: {
      maxQuestions: number;
      stepScore: number;
      skipTO: number;
      maxErrorsPerQuestion: number;
      maxWrongQuestion: number;
      options: number;
      userResponseTO: number;
    };
  };
  rest: {
    errorCodes: {
      notFound: string;
    };
  };
  tp: {
    fbPixelId: string;
  };
}

export default constants;
